<template>
  <v-container fill-height fluid>
    <v-layout align-center justify-center>
      <v-flex lg4 md5 sm8 xl3 xs12>
        <v-card class="elevation-12">
          <v-toolbar extension-height="0">
            <v-toolbar-title class="headline text-uppercase">
              <span>EUHFORIA</span>
              <span class="font-weight-light">online</span>
            </v-toolbar-title>
            <v-progress-linear
              :active="$wait.is('busy')"
              :indeterminate="true"
              class="ma-0"
              height="4"
              slot="extension"
              style="top: -2px;"
            >Progress?</v-progress-linear>
          </v-toolbar>

          <v-card-text>
            <div class="mt-2">
              <v-form>
                <v-text-field disabled label="Email" name="email" prepend-icon="email" type="text" v-model="user.email"></v-text-field>
                <v-text-field
                  disabled
                  id="password"
                  label="Password"
                  name="password"
                  prepend-icon="lock"
                  type="password"
                  v-model="user.password"
                ></v-text-field>
              </v-form>
              <div class="text-xs-center">
                <v-btn @click="login" class="mb-3" disabled large>Login</v-btn>
                <p class="d-none">
                  Don't have an account yet?
                  <router-link :to="{name: 'signup'}">Sign up</router-link>
                  <br />
                  <router-link :to="{name: 'reset-password'}">Forgot your password?</router-link>
                </p>
                <v-alert :value="true" outline type="info">
                  EUHFORIA Online is currently available only to VSC users.
                  <br />Please, obtain a VSC account at
                  <a href="https://www.vscentrum.be/">https://www.vscentrum.be/</a>.
                </v-alert>
              </div>
            </div>

            <v-divider class="mt-3 mb-4"></v-divider>

            <div>
              <VscAuthBtn :label="'Sign in with VSC'" />
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
.v-toolbar__extension {
  padding: 0px !important;
}
</style>

<script>
import { required } from 'vuelidate/lib/validators';
import VscAuthBtn from '@/components/VscAuthBtn.vue';
import { onLogin } from '@/vue-apollo';
import { TOKEN_AUTH } from '@/graphql.gql';

export default {
  components: { VscAuthBtn },
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
    };
  },
  validations: {
    user: {
      email: {
        required,
      },
      password: {
        required,
      },
    },
  },
  methods: {
    async login() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$snackbar.show('Please, fill the credentials.');
        return;
      }
      try {
        this.$wait.start('busy');
        const response = await this.$apollo.mutate({
          mutation: TOKEN_AUTH,
          variables: this.user,
        });
        await onLogin(this.$apollo.provider.defaultClient, response.data.tokenAuth.token);
        this.$store.dispatch('refreshToken');
      } catch (error) {
        this.$snackbar.show('Please, double-check your credentials and try again.');
      } finally {
        this.$wait.end('busy');
      }
      this.$router.push({ name: 'runs' });
    },
  },
};
</script>
